import React from "react";
import Marquee from "react-fast-marquee";

export default function MarqueeBar({ content }) {
  const text = content?.marquee?.text || "O TEU NEGÓCIO TEM MAIS POTENCIAL. ✳";
  return (
    <section
      data-testid="marquee-section"
      className="bg-peca-yellow text-peca-black py-5 border-y-2 border-peca-black select-none"
    >
      <Marquee speed={55} gradient={false} autoFill>
        <span className="font-display font-extrabold uppercase text-2xl md:text-4xl tracking-tight px-6">
          {text}
        </span>
      </Marquee>
    </section>
  );
}
